import BrokerKambalaContainer from "./BrokerKambalaContainer"

export default BrokerKambalaContainer;